import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { TagError } from '../../../../models/company-call-history/company-call-history.model';

let nextId = 0;

@Component({
  selector: 'call-history-tag-input',
  templateUrl: './tag-input.component.html',
  styleUrls: ['./tag-input.component.scss']
})
export class TagInputComponent {
  @Input() value = '';
  @Input() isEditing: boolean = false;
  @Output() valueChange = new EventEmitter<string>();
  @Input() error: TagError | null = null;
  @Input() placeholder = '';
  @Output() enter = new EventEmitter<void>();
  @Output() escape = new EventEmitter<void>();
  @ViewChild('model') model!: NgModel;
  readonly errorId = `tag-input-error-${nextId++}`;
  readonly errorKeyPrefix = 'events.company-call-history.events-all.general-settings.accordion.tags.validation.';

  resetState(): void {
    this.model.control.markAsPristine();
    this.model.control.markAsUntouched();
  }
}